const $ = (selector, context) => (context || document).querySelector(selector)
const $$ = (selector, context) => [].slice.call( (context || document).querySelectorAll(selector) )

export { $, $$ }